import { render } from "./EditBuyerView.vue?vue&type=template&id=5b0b729d"
import script from "./EditBuyerView.vue?vue&type=script&lang=js"
export * from "./EditBuyerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__